import Swal from 'sweetalert2'

const _Alert = Swal.mixin({
    title: '',
    heightAuto: false,
})

export default class Alert {

    static success(message) {
        _Alert.fire({
            html: message,
            type: 'success',
        })
    }

    static error(message) {
        _Alert.fire({
            html: message,
            type: 'error',
        })
    }

    static danger(message) {
        _Alert.fire({
            html: message,
            type: 'error',
        })
    }

    static warning(message) {
        _Alert.fire({
            html: message,
            type: 'warning',
        })
    }

    static info(message) {
        _Alert.fire({
            html: message,
            type: 'info',
        })
    }

    static question(message) {
        _Alert.fire({
            html: message,
            type: 'question',
        })
    }

    static withAction(message, type = 'success') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                title: '',
                html: message,
                type: type,
                confirmButtonColor: '#5F91BA',
                confirmButtonText: 'Ok',
                heightAuto: false
            }).then(resolve).catch(reject)
        })
    }

    static confirmation(message, type = 'question') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                title: '',
                html: message,
                type: type,
                showCancelButton: true,
                cancelButtonColor: '#E03F31',
                confirmButtonColor: '#488A99',
                confirmButtonText: 'Confirm',
                heightAuto: false
            }).then(result => {
                if (result.value) {
                    resolve(true)
                }
                reject(false)
            }).catch(() => {
                reject(false);
            })
        })
    }

    /**
     * Success alert.
     * @param message
     */
    static withDelay(message, type = 'success', time = 2000) {
        _Alert.fire({
            title: "",
            html: message,
            type: type,
            timer: time,
            showConfirmButton: false,
            heightAuto: false
        })
    }

    static options(message, options, type = 'question'){
        return new Promise((resolve, reject) => {
            _Alert.fire({
                html: message,
                input: 'select',
                inputOptions: options,
                type: type,
            }).then((result) => {
                if (result.value) {
                    resolve({ id: result.value, value : options[result.value]})
                }
                reject(null)
            })
        })
    }

    static create(){
        return _Alert;
    }
}
